import { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { TermsAndConditionsList } from '@/components/_promo/components/TermsAndConditionsList';
import { config } from '../../helpers';
import {
  ScTermsBackButton,
  ScTermsBackWrapper,
  ScTermsBlock,
  ScTermsTitle,
} from './styled';

const { translation, fsCount, validate } = config.default;

interface ITermsBackProps {
  onBack: () => void;
}

export const TermsBack = ({ onBack }: ITermsBackProps) => {
  const { t } = useTranslation(translation);
  const termsBlockRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(() => {
    const el = termsBlockRef.current;
    if (!el) return;
    el.dataset.atBottom = String(
      el.scrollTop + el.clientHeight >= el.scrollHeight
    );
  }, []);

  useEffect(() => {
    handleScroll();
  }, [handleScroll]);

  return (
    <ScTermsBackWrapper>
      <ScTermsTitle>{t('termsTitle')}</ScTermsTitle>
      <ScTermsBlock
        data-at-bottom="false"
        onScroll={handleScroll}
        ref={termsBlockRef}
      >
        <TermsAndConditionsList
          defaultFsCount={fsCount}
          translation={translation}
          validDate={validate}
        />
      </ScTermsBlock>
      <ScTermsBackButton onClick={onBack} type="button">
        {t('termsBack')}
      </ScTermsBackButton>
    </ScTermsBackWrapper>
  );
};
